import { useForm, useFormContext } from 'react-hook-form';

import { MAP_LAYER_FACTS, ThreatType } from '@/api/rest/resources/types/fact';

import { LAYER_OPTIONS } from '../constants';

export const DEFAULT_LAYER_OPACITY = 40;
export const DEFAULT_LAYER_OPACITIES = {
  [MAP_LAYER_FACTS.gbif_species_occurrence]: 100,
  [MAP_LAYER_FACTS.habitat_intactness_raster_urls]: 80,
  [MAP_LAYER_FACTS.ecosystem_integrity_index_map_url]: 80,
  [MAP_LAYER_FACTS.osm_protected_areas]: 80,
  [MAP_LAYER_FACTS.iucn_protected_areas]: 80,
};

type ControlsFormFieldValues = {
  year: string;
  layer: string;
  radius: string;
  habitatIntactnessThreats: ThreatType[];
  layerOpacity: number;
};
export const useControlsForm = useForm<ControlsFormFieldValues>;
export const useControlsContext = useFormContext<ControlsFormFieldValues>;

export const useMapSelectedLayer = () => {
  const controlsForm = useControlsContext();
  const layer = controlsForm.watch('layer');

  return LAYER_OPTIONS.find((opt) => opt.value === layer);
};
